import { create } from 'zustand';

export type Language = 'en' | 'zh';

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
}

// Update the HTML lang attribute
function updateHtmlLang(language: Language) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }
}

// Get initial language from localStorage, default to English
function getInitialLanguage(): Language {
  if (typeof window === 'undefined') return 'en';

  const stored = localStorage.getItem('language') as Language | null;
  if (stored === 'en' || stored === 'zh') {
    // Update HTML lang on initial load
    updateHtmlLang(stored);
    return stored;
  }

  // Default to English for first-time visitors
  return 'en';
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: getInitialLanguage(),
  setLanguage: (language: Language) => {
    localStorage.setItem('language', language);
    updateHtmlLang(language);
    set({ language });
  },
}));
